<template>
  <div>
    <p
      v-if="document.data && document.data.duplicatedDataValidation === false"
      class="text-danger font-larger font-weight-bold"
    >
      <span>
        Uwaga: Wniosek z takimi danymi został już złożony. W przypadku konieczności edycji proszę o kontakt&nbsp;
      </span>

      <span v-if="submitToSchool">ze&nbsp;szkołą.</span>

      <span v-else>z&nbsp;Wydziałem Oświaty i&nbsp;Wychowania UM.</span>
    </p>

    <p v-if="errors" class="text-danger font-larger font-weight-bold">
      {{ errors }}
    </p>

    <w-input
      class="form-group"
      :model="schema.mdokId"
      @input="loadDocumentName(schema.mdokId.$model, 'mdok/getDocumentNameAndIncomeDate')"
    />

    <div v-if="documentName && schema.mdokId.$model" class="form-group">
      <p>
        Wybrano dokument: <b>{{ documentName }}</b>
      </p>
    </div>

    <w-datepicker v-if="!hasDeliveryDate" class="form-group" :model="schema.deliveryDate" />

    <w-input class="form-group" :model="schema.epuapAddress" />
  </div>
</template>

<script>
import { components } from '@witkac/bootstrap4-components';
import { mapState } from 'vuex';

import { mdokDocumentMixin } from '@/mixins/mdokDocument';

// @vuese
// Formularz uzasadnienia
// @group ActionData
export default {
  components,
  mixins: [mdokDocumentMixin],
  props: {
    // schema
    schema: { type: Object, required: true },
    // dokument
    selectedDocument: { type: Object, required: false }
  },
  computed: {
    ...mapState({
      storedDocument: state => state.documentIndex?.data
    }),
    errors() {
      return this.document?.data?.veryImportantErrors;
    },
    document() {
      return this.selectedDocument || this.storedDocument;
    },
    hasDeliveryDate() {
      return !!this.document.values?.DELIVERY_DATE;
    },
    submitToSchool() {
      return this.document.data?.school?.financingType === 1;
    }
  },
  methods: {
    // Ustawia pobraną datę
    afterNameGet(data) {
      const contact = data?.contact?.replace(/@epuap\d?/i, '');
      this.schema.epuapAddress.$setData(contact || undefined);

      if (this.hasDeliveryDate) {
        return;
      }
      this.schema.deliveryDate.$setData(data?.date || undefined);
    }
  }
};
</script>
